export default class EarlyBirdQualification {
  /**
   * @type {number}
   */
  id;

  /**
   * @type {number}
   */
  clientId;

  /**
   * @type {number}
   */
  refundAmt;

  /**
   * @type {number}
   */
  refundType;

  /**
   * @type {number}
   */
  earlyBirdAmt;

  /**
   * @type {boolean}
   */
  fmsDebt;

  /**
   * @type {boolean}
   */
  riskyDependents;

  /**
   * @type {boolean}
   */
  over21;

  /**
   * @type {boolean}
   */
  isApproved;

  /**
   * @type {boolean}
   */
  submitted;

  /**
   * @type {string[]}
   */
  reasonsDeclined;

  /**
   * @type {string}
   */
  dateAdded;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.clientId != null) {
        this.clientId = opts.clientId;
      }
      if (opts.refundAmt != null) {
        this.refundAmt = opts.refundAmt;
      }
      if (opts.refundType != null) {
        this.refundType = opts.refundType;
      }
      if (opts.earlyBirdAmt != null) {
        this.earlyBirdAmt = opts.earlyBirdAmt;
      }
      if (opts.fmsDebt != null) {
        this.fmsDebt = opts.fmsDebt;
      }
      if (opts.riskyDependents != null) {
        this.riskyDependents = opts.riskyDependents;
      }
      if (opts.over21 != null) {
        this.over21 = opts.over21;
      }
      if (opts.isApproved != null) {
        this.isApproved = opts.isApproved;
      }
      if (opts.submitted != null) {
        this.submitted = opts.submitted;
      }
      if (opts.reasonsDeclined != null) {
        this.reasonsDeclined = [...opts.reasonsDeclined];
      }
      if (opts.dateAdded != null) {
        this.dateAdded = opts.dateAdded;
      }
    }
  }
}
